/**
 * Brazilian banks, digital banks and fintechs that hold accounts, by COMPE code, sorted by name. It is the list the
 * account's bank is picked from (the field searches it by name or code); Pagar.me checks the code on its side.
 * Not every institution of the Central Bank's list: those a person opens an account in to receive their sales.
 */
export const BANKS: { code: string; name: string }[] = [
  { code: "246", name: "ABC Brasil" },
  { code: "075", name: "ABN Amro" },
  { code: "332", name: "Acesso" },
  { code: "121", name: "Agibank" },
  { code: "085", name: "Ailos" },
  { code: "213", name: "Arbi" },
  { code: "461", name: "Asaas" },
  { code: "188", name: "Ativa Investimentos" },
  { code: "025", name: "Banco Alfa" },
  { code: "024", name: "Banco Bandepe" },
  { code: "003", name: "Banco da Amazônia" },
  { code: "083", name: "Banco da China" },
  { code: "001", name: "Banco do Brasil" },
  { code: "004", name: "Banco do Nordeste" },
  { code: "012", name: "Banco Inbursa" },
  { code: "074", name: "Banco J. Safra" },
  { code: "348", name: "Banco XP" },
  { code: "047", name: "Banese" },
  { code: "021", name: "Banestes" },
  { code: "755", name: "Bank of America" },
  { code: "037", name: "Banpará" },
  { code: "041", name: "Banrisul" },
  { code: "330", name: "Bari" },
  { code: "144", name: "Bexs" },
  { code: "318", name: "BMG" },
  { code: "007", name: "BNDES" },
  { code: "752", name: "BNP Paribas" },
  { code: "017", name: "BNY Mellon" },
  { code: "248", name: "Boavista" },
  { code: "107", name: "Bocom BBM" },
  { code: "301", name: "BPP" },
  { code: "126", name: "BR Partners" },
  { code: "063", name: "Bradescard" },
  { code: "237", name: "Bradesco" },
  { code: "122", name: "Bradesco BERJ" },
  { code: "394", name: "Bradesco Financiamentos" },
  { code: "070", name: "BRB" },
  { code: "092", name: "BRK" },
  { code: "142", name: "Broker Brasil" },
  { code: "218", name: "BS2" },
  { code: "208", name: "BTG Pactual" },
  { code: "655", name: "BV" },
  { code: "336", name: "C6 Bank" },
  { code: "104", name: "Caixa Econômica Federal" },
  { code: "412", name: "Capital" },
  { code: "324", name: "Cartos" },
  { code: "130", name: "Caruana" },
  { code: "739", name: "Cetelem" },
  { code: "320", name: "China Construction Bank" },
  { code: "233", name: "Cifra" },
  { code: "477", name: "Citibank" },
  { code: "241", name: "Clássico" },
  { code: "403", name: "Cora" },
  { code: "010", name: "Credicoamo" },
  { code: "097", name: "Credisis" },
  { code: "222", name: "Credit Agricole" },
  { code: "342", name: "Creditas" },
  { code: "321", name: "Crefaz" },
  { code: "069", name: "Crefisa" },
  { code: "133", name: "Cresol" },
  { code: "707", name: "Daycoval" },
  { code: "487", name: "Deutsche Bank" },
  { code: "654", name: "Digimais" },
  { code: "335", name: "Digio" },
  { code: "364", name: "Efí" },
  { code: "149", name: "Facta" },
  { code: "265", name: "Fator" },
  { code: "224", name: "Fibra" },
  { code: "094", name: "Finaxis" },
  { code: "450", name: "Fitbank" },
  { code: "390", name: "GM" },
  { code: "064", name: "Goldman Sachs" },
  { code: "062", name: "Hipercard" },
  { code: "189", name: "HS Financeira" },
  { code: "269", name: "HSBC" },
  { code: "653", name: "Indusval" },
  { code: "542", name: "InfinitePay" },
  { code: "077", name: "Inter" },
  { code: "139", name: "Intesa Sanpaolo" },
  { code: "341", name: "Itaú" },
  { code: "184", name: "Itaú BBA" },
  { code: "029", name: "Itaú Consignado" },
  { code: "479", name: "ItauBank" },
  { code: "376", name: "J.P. Morgan" },
  { code: "217", name: "John Deere" },
  { code: "383", name: "Juno" },
  { code: "757", name: "KEB Hana" },
  { code: "399", name: "Kirton" },
  { code: "243", name: "Máxima" },
  { code: "323", name: "Mercado Pago" },
  { code: "389", name: "Mercantil do Brasil" },
  { code: "381", name: "Mercedes-Benz" },
  { code: "370", name: "Mizuho" },
  { code: "746", name: "Modal" },
  { code: "456", name: "MUFG" },
  { code: "753", name: "NBC Bank" },
  { code: "536", name: "Neon" },
  { code: "260", name: "Nubank" },
  { code: "169", name: "Olé Consignado" },
  { code: "212", name: "Original" },
  { code: "079", name: "Original do Agronegócio" },
  { code: "355", name: "Ótimo" },
  { code: "290", name: "PagBank" },
  { code: "623", name: "Pan" },
  { code: "254", name: "Paraná Banco" },
  { code: "380", name: "PicPay" },
  { code: "100", name: "Planner" },
  { code: "125", name: "Plural" },
  { code: "093", name: "Pólocred" },
  { code: "108", name: "PortoCred" },
  { code: "329", name: "QI" },
  { code: "747", name: "Rabobank" },
  { code: "633", name: "Rendimento" },
  { code: "741", name: "Ribeirão Preto" },
  { code: "120", name: "Rodobens" },
  { code: "422", name: "Safra" },
  { code: "270", name: "Sagitur" },
  { code: "033", name: "Santander" },
  { code: "751", name: "Scotiabank" },
  { code: "743", name: "Semear" },
  { code: "756", name: "Sicoob" },
  { code: "748", name: "Sicredi" },
  { code: "366", name: "Société Générale" },
  { code: "637", name: "Sofisa" },
  { code: "462", name: "Stark" },
  { code: "197", name: "Stone" },
  { code: "404", name: "SumUp" },
  { code: "082", name: "Topázio" },
  { code: "352", name: "Toro" },
  { code: "387", name: "Toyota" },
  { code: "143", name: "Treviso" },
  { code: "136", name: "Unicred" },
  { code: "091", name: "Unicred Central RS" },
  { code: "099", name: "Uniprime Central" },
  { code: "084", name: "Uniprime Norte do Paraná" },
  { code: "393", name: "Volkswagen" },
  { code: "119", name: "Western Union" },
  { code: "280", name: "Will Bank" },
  { code: "124", name: "Woori Bank" },
  { code: "102", name: "XP Investimentos" },
];
